import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import zhHant from "./translations/zhHant.json"
import zhHans from "./translations/zhHans.json"
import en from "./translations/en.json"
import jp from "./translations/jp.json"

const language = localStorage.getItem("language") || "zh-Hant"

i18n.use(initReactI18next).init({
  resources: {
    "zh-Hant": zhHant,
    "zh-Hans": zhHans,
    "en-US": en,
    "ja-JP": jp,
  },
  lng: language,
  debug: process.env.REACT_APP_CONFIG_FILE !== "production",
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
})

export default i18n
